import { render, staticRenderFns } from "./BusKnowledgeTypeList.vue?vue&type=template&id=5fa075e9&scoped=true&"
import script from "./BusKnowledgeTypeList.vue?vue&type=script&lang=js&"
export * from "./BusKnowledgeTypeList.vue?vue&type=script&lang=js&"
import style0 from "./BusKnowledgeTypeList.vue?vue&type=style&index=0&id=5fa075e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa075e9",
  null
  
)

export default component.exports